import {useState} from "react";
import {GetNoticesParam} from "../../../models/notice";

export const useGetNoticesParam = () => {
    const [getNoticesParam, setGetNoticesParam] = useState<GetNoticesParam>({
        page: 1,
        pageSize: 20
    })

    return {
        getNoticesParam,
        setPage: (page: number) => setGetNoticesParam({ ...getNoticesParam, page }),
    }
}